import BaseApi from './BaseApi'
import { appendRequestParameters } from '@/helpers/Utils'
/**
 * Environment settings.
 * @param {Object, Array, String, Null} params.organizations
 * @param {Object, Array, String, Null} params.fleets
 */

export default class DeviceApi extends BaseApi {
    async getDevices (params = {
        name: null,
        organizations: null,
        fleets: null,
        vehicleId: null,
        deviceModelId: null,
        deviceProtocolId: null,
        neverReporter: null,
        enabled: null,
        simCard: null,
        unassignedToVehicle: null,
        recorderId: null,
        page: null,
        perPage: null,
        orderBy: null
    }) {
        const request = new URLSearchParams()

        if (params.page && params.perPage) {
            const skip = (params.page - 1) * params.perPage
            request.append('Skip', skip.toString())
            request.append('Take', params.perPage)
        }

        if (params.name) {
            request.append('Name', `%${params.name}%`)
        }

        if (null != params.organizations) {
            appendRequestParameters('OrganizationId', request, params.organizations, 'id')
        } else if (params.organization != null){
            appendRequestParameters('OrganizationId', request, params.organization, 'id')
        }

        if (params.fleets) {
            appendRequestParameters('FleetId', request, params.fleets, 'id')
        }

        if (params.vehicleId) {
            request.append('VehicleId', params.vehicleId)
        }

        if (params.deviceModelId) {
            request.append('DeviceModelId', params.deviceModelId)
        }

        if (params.deviceProtocolId) {
            request.append('DeviceProtocolId', params.deviceProtocolId)
        }

        if (null != params.neverReporter) {
            request.append('NeverReporter', params.neverReporter)
        }

        if (null != params.enabled) {
            request.append('Enabled', params.enabled)
        }

        if (params.simCard) {
            request.append('SimCard', params.simCard)
        }

        if (params.orderBy) {
            request.append('OrderBy', params.orderBy)
        }

        if (params.recorderId) {
            request.append('RecorderId', params.recorderId)
        }

        if (params.unassignedToVehicle) {
            request.append('UnassignedToVehicle', params.unassignedToVehicle)
        }
        return this.get('/api/v1.0/devices', request)
    }
    async getDevice (deviceId) {
        return this.get(`/api/v1.0/devices/${deviceId}`)
    }
    async getDevicesWithStreamingAbility () {
        return this.get(`/api/v1.0/devices/withStreamingAbility`)
    }
    async editDevice (params = {
        id: null,
        dataToCapture: null,
        channelFlag: null,
        deviceModelId: null,
        deviceProtocolId: null,
        firmwareVersion: null,
        simNumber: null,
        serialNumber: null,
        enabled: null,
        customerSim: null,
        automaticVideoDownload: null
    }) {
        return this.put('/api/v1.0/devices', params)
    }
    async createDevice (params = {
        hardwareId: null,
        dataToCapture: null,
        channelFlag: null,
        deviceModelId: null,
        deviceProtocolId: null,
        firmwareVersion: null,
        simNumber: null,
        serialNumber: null,
        enabled: null,
        customerSim: null,
        automaticVideoDownload: null,
        fleetId: null,
        vehicleId: null,
        organizationId: null
    }) {
        return this.post('/api/v1.0/devices', params)
    }
    async assignDeviceToFleet (deviceId, fleetId) {
        return this.put(`/api/v1.0/devices/assignFleet`, {
            deviceId: deviceId,
            fleetId: fleetId
        })
    }
    async unassignDeviceFromFleet (deviceId) {
        return this.put(`/api/v1.0/devices/unassignFleet`, {
            deviceId: deviceId
        })
    }
    async assignDeviceToVehicle (deviceId, vehicleId) {
        return this.put(`/api/v1.0/devices/assignVehicle`, {
            deviceId: deviceId,
            vehicleId: vehicleId
        })
    }
    async unassignDeviceFromVehicle (deviceId) {
        return this.put(`/api/v1.0/devices/unassignVehicle`, {
            deviceId: deviceId
        })
    }
    async assignDeviceToOrganization (deviceId, organizationId) {
        return this.put(`/api/v1.0/devices/assignOrganization`, {
            deviceId: deviceId,
            organizationId: organizationId
        })
    }
    async unassignDeviceFromOrganization (deviceId) {
        return this.put(`/api/v1.0/devices/unassignOrganization`, {
            id: deviceId
        })
    }
    async importDevices (file) {
        return this.post(`/api/v1.0/devices/importDevices`, file)
    }
    async deleteDevice (id) {
        return this.delete(`/api/v1.0/devices/${id}`, {
            HardwareId: id
        })
    }
    async getTemplate () {
        return this.get(`/api/v1.0/devices/importTemplate`)
    }
    async move (devices) {
        return this.post(`/api/v1.0/devices/move`, {
            devices: devices
        })
    }
}
